import { GenericStatus } from "./props";

const VesselRequisitionItemPricingStatus: GenericStatus[] = [
    {key: "draft", text: "Draft", tagVariant: 'default', isDefault: true},
    {key: "pending", text: "Pending", tagVariant: 'warning'},
    {key: "approved", text: "Approved", tagVariant: 'active'},
    {key: "rejected", text: "Rejected", tagVariant: 'error'}
]                                                        

export default VesselRequisitionItemPricingStatus;